import React from "react"
import { FaEdit } from "react-icons/fa"
import { type Props } from "./_types"
const IconEdit: React.FC<Props> = ({ size = 15, color = "#fff" }): React.ReactElement => {
  return <FaEdit size={size} color={color} />
}

export default IconEdit
